<header class="{{getTranslateDefaultLang}}">
  <div class="container-fluid container-lg">
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand" href="#">
        @if (!isAegBrandingCulture()) {
          <img src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEELONELX25/Logo-Electrolux.svg"
            class="logo-aeg">
        }
        @if (isAegBrandingCulture()) {
          <img src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/logo_aeg.png"
            class="logo-aeg da-DK">
        }

        <!--<img src="{{'local-reseller-logo' | translate}}" alt="" class="power-logo d-inline-block d-md-none ms-3">-->

      </a>
    </nav>
  </div>
</header>